
import * as React from "react";
import { Provider } from "react-redux";

import { TooltipProvider } from "@/components/ui/tooltip"

import "./src/styles/global.css";

import "@fontsource/roboto";
import "@fontsource/roboto/800-italic";
import "@fontsource/national-park";

import { ConnectedRadioPlayer as FestRadio } from "./src/components/radio/radio";
import createStore from "./src/state/createStore";

const store = createStore();

// eslint-disable-next-line react/display-name,react/prop-types
export const wrapRootElement = ({ element }) => (
  <Provider className="dark" store={store}>{element}</Provider>
);

export const wrapPageElement = ({ element }) => (
  <TooltipProvider>
    {element}
    <FestRadio />
  </TooltipProvider>
);